import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import Login from '../views/Login.vue'
import HomeMenu from "../views/HomeMenu";
import Search from "../views/Search";
import User from "../views/User";
import PickupCode from "../views/HomeMenu/PickupCode";
import RegisterDelivery from "../views/register/RegisterDelivery";
import Agreement from "../views/Agreement";
import Fleet from "../views/HomeMenu/Fleet";
import LadingBill from "../views/HomeMenu/LadingBill";
import MyOut from "../views/HomeMenu/MyOut";
import AddOut from "../views/Out/AddOut";
import WarrantyBook from "../views/HomeMenu/WarrantyBook";
import InstockCurSel from "../views/HomeMenu/InstockCurSel";
import InstockSel from "../views/HomeMenu/InstockSel";
import InstockOutSel from "../views/HomeMenu/InstockOutSel";
import InstockTranSel from "../views/HomeMenu/InstockTranSel";
import jgInstockSel from "../views/HomeMenu/jgInstockSel";
import jgOutstockSel from "../views/HomeMenu/jgOutstockSel";
import jgProcessSel from "../views/HomeMenu/jgProcessSel";
import jgCurStockSel from "../views/HomeMenu/jgCurStockSel";
import OrderPlanList from "../views/HomeMenu/OrderPlanList";

import NewsList from "../views/HomeMenu/NewsList";
import NewsDetail from "../views/HomeMenu/NewsDetail";
import SummaryList from "../views/HomeMenu/SummaryList";
import AboutUs from "../views/HomeMenu/AboutUs";
import Business from "../views/HomeMenu/Business";
import ContactUs from "../views/HomeMenu/ContactUs";
import UploadFile from "../views/HomeMenu/UploadFile";


import ThLogin from '../thviews/Login.vue'
import ThHome from '../thviews/Home.vue'
import thAll from '../thviews/Home.vue'
import HomeMenuTh from "../thviews/HomeMenu";
import SearchTh from "../thviews/Search";
import UserTh from "../thviews/User";
import PickupCodeTh from "../thviews/HomeMenu/PickupCode";
import FleetTh from "../thviews/HomeMenu/Fleet";
import LadingBillTh from "../thviews/HomeMenu/LadingBill";
import MyOutTh from "../thviews/HomeMenu/MyOut";
import OutnotifySel from "../thviews/HomeMenu/OutnotifySel";
import WarrantyBookTh from "../thviews/HomeMenu/WarrantyBook";
import RegisterDeliveryTh from "../thviews/register/RegisterDelivery";

Vue.use(VueRouter)
Vue.use(require('vue-moment'));

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/',
                name: 'HomeMenu',
                component: HomeMenu,
                meta: {index: 0},
            },
            {
                path: '/Home/HomeMenu',
                name: 'HomeMenu',
                component: HomeMenu,
                meta: {index: 0}
            },
            {
                path: '/Home/Search',
                name: 'Search',
                component: Search,
                meta: {index: 1}
            },
            {
                path: '/Home/User',
                name: 'User',
                component: User,
                meta: {index: 2}
            },
            {
                path: '/Home/PickupCode',
                name: 'PickupCode',
                component: PickupCode,
                meta: {index: 3}
            },
            {
                path: '/Home/Fleet',
                name: 'Fleet',
                component: Fleet,
                meta: {index: 3}
            },
            {
                path: '/Home/LadingBill',
                name: 'LadingBill',
                component: LadingBill,
                meta: {index: 3}
            },
            {
                path: '/Home/MyOut',
                name: 'MyOut',
                component: MyOut,
                meta: {index: 3}
            },
            {
                path: '/Home/WarrantyBook',
                name: 'WarrantyBook',
                component: WarrantyBook,
                meta: {index: 3}
            },
            {
                path: '/Home/InstockCurSel',
                name: 'InstockCurSel',
                component: InstockCurSel,
                meta: {index: 3}
            },
            {
                path: '/Home/InstockSel',
                name: 'InstockSel',
                component: InstockSel,
                meta: {index: 3}
            },
            {
                path: '/Home/InstockOutSel',
                name: 'InstockOutSel',
                component: InstockOutSel,
                meta: {index: 3}
            },
            {
                path: '/Home/InstockTranSel',
                name: 'InstockTranSel',
                component: InstockTranSel,
                meta: {index: 3}
            },
            {
                path: '/Home/jgInstockSel',
                name: 'jgInstockSel',
                component: jgInstockSel,
                meta: {index: 3}
            },
            {
                path: '/Home/jgOutstockSel',
                name: 'jgOutstockSel',
                component: jgOutstockSel,
                meta: {index: 3}
            },
            {
                path: '/Home/jgProcessSel',
                name: 'jgProcessSel',
                component: jgProcessSel,
                meta: {index: 3}
            },
            {
                path: '/Home/jgCurStockSel',
                name: 'jgCurStockSel',
                component: jgCurStockSel,
                meta: {index: 3}
            },
            {
                path: '/Home/OrderPlanList',
                name: 'OrderPlanList',
                component: OrderPlanList,
                meta: {index: 3}
            },
        ]
    },
    {
        path: '/thAll',
        name: 'thAll',
        component: thAll,
        children: [
            {
                path: '/',
                name: 'thHomeMenu',
                component: HomeMenuTh,
                meta: {index: 0},
            },
            {
                path: '/Home/HomeMenuTh',
                name: 'HomeMenuTh',
                component: HomeMenuTh,
                meta: {index: 0}
            },
            {
                path: '/Home/SearchTh',
                name: 'SearchTh',
                component: SearchTh,
                meta: {index: 1}
            },
            {
                path: '/Home/UserTh',
                name: 'UserTh',
                component: UserTh,
                meta: {index: 2}
            },
            {
                path: '/Home/PickupCodeTh',
                name: 'PickupCodeTh',
                component: PickupCodeTh,
                meta: {index: 3}
            },
            {
                path: '/Home/FleetTh',
                name: 'FleetTh',
                component: FleetTh,
                meta: {index: 3}
            },
            {
                path: '/Home/LadingBillTh',
                name: 'LadingBillTh',
                component: LadingBillTh,
                meta: {index: 3}
            },
            {
                path: '/Home/MyOutTh',
                name: 'MyOutTh',
                component: MyOutTh,
                meta: {index: 3}
            },
            {
                path: '/Home/OutnotifySel',
                name: 'OutnotifySel',
                component: OutnotifySel,
                meta: {index: 3}
            },
            {
                path: '/Home/WarrantyBookTh',
                name: 'WarrantyBookTh',
                component: WarrantyBookTh,
                meta: {index: 3}
            },


        ]
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/Login',
        name: 'Login',
        component: Login,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/RegisterDelivery',
        name: 'RegisterDelivery',
        component: RegisterDelivery,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/RegisterDeliveryTh',
        name: 'RegisterDeliveryTh',
        component: RegisterDeliveryTh,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/Agreement',
        name: 'Agreement',
        component: Agreement,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/AddOut',
        name: 'AddOut',
        component: AddOut,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/thLogin',
        name: 'thLogin',
        component: ThLogin,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/thhome',
        name: 'thhome',
        component: ThHome,
        meta: {
            skip_auth: true
        }
    },
    {
        path: '/Home/AboutUs',
        name: 'AboutUs',
        component: AboutUs,
        meta: {
            title: '公司简介',
            skip_auth: true
        }
    },
    {
        path: '/Home/Business',
        name: 'Business',
        component: Business,
        meta: {
            title: '业务介绍',
            skip_auth: true
        }
    },
    {
        path: '/Home/ContactUs',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
            title: '联系我们',
            skip_auth: true
        }
    },
    {
        path: '/Home/SummaryList',
        name: 'SummaryList',
        component: SummaryList,
        meta: {
            title: '行情资讯',
            skip_auth: true
        }
    },
    {
        path: '/Home/NewsList',
        name: 'NewsList',
        component: NewsList,
        meta: {
            title: '公司新闻',
            skip_auth: true
        }
    },
    {
        path: '/Home/NewsDetail/:newsId',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
            title: '新闻详情',
            skip_auth: true
        }
    },
    {
        path: '/Home/UploadFile/:outnotifyOrderId/:appid/:ouid',
        name: 'UploadFile',
        component: UploadFile,
        meta: {
            title: '上传图片',
            skip_auth: true
        }
    },
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {

    window.document.title = to.meta.title == undefined?process.env.VUE_APP_CUSTOMER_TITLE:to.meta.title

    //在已登录状态下不允许退回登录页面去
    if (to.name == 'login' && store.state.token) {
        next(false);
        return;
    }

    //拦截需要登录但是未登录的页面请求
    if (to.matched.some(record => record.meta.skip_auth !== true) && !store.state.token) {
        next({
            path: '/login'
        })
    } else {
        next()
    }
})


export default router
